// extracted by mini-css-extract-plugin
export default {"ThemeToggle":"ThemeToggle_ThemeToggle__nGqOF","Icon":"ThemeToggle_Icon__TWlpe"};